import { isMobile } from '../_app/cuchillo/core/Basics';
import { ControllerPage } from '../_app/cuchillo/pages/ControllerPage';
import Header from '../layout/Header';
import Default from './Default';

export default class Home extends Default {
  showHeader = false;

  constructor() {
    super();

    if (!isMobile) Header.directHide();
  }
}

ControllerPage._addPage('home', Home);
